const arrayOf = (num: number): number[] => [...Array(num).keys()];

export default arrayOf;
